'use client';

import { CheckCircle, ArrowCircleUp, Warning, WarningOctagon, Info } from "../../../../react-icons.js";
const variantToIconMap = {
  default: Info,
  danger: WarningOctagon,
  warning: Warning,
  upsell: ArrowCircleUp,
  success: CheckCircle
};
export {
  variantToIconMap
};
